import React from "react";
import { useParams } from "react-router";
import { observer } from "mobx-react-lite";

import { analyticsTracker } from "@utils/analytics";
import { useRootAppStore } from "@hooks";

export const EventSwitcher = observer(function EventSwitcher() {
	const { moveLeft, moveRight, isAvailable } =
		useRootAppStore().eventSwitcherViewStore;

	if (!isAvailable) {
		return null;
	}

	return (
		<div className="header__nav header--sub__nav">
			<SwitcherButton action={moveLeft} direction={"left"} />
			<SwitcherButton action={moveRight} direction={"right"} />
		</div>
	);
});

const SwitcherButton = observer(function SwitcherButton(
	props: SwitcherButton_PropTypes
) {
	const { action, direction } = props;

	const params: { eventIds: string } = useParams();

	return (
		<button
			type="button"
			onClick={() => {
				action(params.eventIds);
				analyticsTracker.trackEventSwitcherInteraction(
					direction === "left" ? "previous" : "next"
				);
			}}
			className={
				(direction === "left"
					? "header--sub__prev"
					: "header--sub__next") +
				" btn btn--square btn--square--sml btn--primary--inverted"
			}
		>
			<i className={"u-icon u-icon--tny u-icon--arrow-" + direction} />
		</button>
	);
});

type SwitcherButton_PropTypes = {
	action: Function;
	direction: string;
};
